import { Tooltip } from "@/components/ui/tooltip";
import { PurchaseOrderIntentListItem } from "@/pages/supplies-requests/purchase-order-intent/schema/purchase-order-intent.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: PurchaseOrderIntentListItem;
  handleDetail: (item: PurchaseOrderIntentListItem) => void;
}

export const PurchaseOrderIntentActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item)}
          data-testid="purchase-order-intent-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
